<template>
  <div class="d-flex p-3 flex-column">
    <GmbSection :displayLevel="1" title="Info">
      <template #picto>
        <FdText colorTheme4 fa>
          <i class="fas fa-map-marker-alt"/>
        </FdText>
      </template>

      <GmbRow alignControlsOnTop>
        <template #picto>
          <FdText colorTheme4 fa>
            <i class="fa-solid fa-id-card-clip"/>
          </FdText>
        </template>

        <div class="d-flex flex-column">
          <FdText bold colorTheme4 tag="label">ID</FdText>
          <FdText class="mt-1" tag="span">{{ id }}</FdText>
        </div>
      </GmbRow>

      <GmbRow v-if="address" alignControlsOnTop class="mt-2">
        <template #picto>
          <FdText colorTheme4 fa>
            <i class="fa-solid fa-signs-post"/>
          </FdText>
        </template>

        <div class="d-flex flex-column">
          <FdText bold colorTheme4 tag="label">Adresse</FdText>
          <FdText class="mt-1" tag="span">{{ address }}</FdText>
        </div>
      </GmbRow>

      <GmbRow alignControlsOnTop class="mt-2">
        <template #picto>
          <FdText colorTheme4 fa>
            <i class="fas fa-building"/>
          </FdText>
        </template>

        <div class="d-flex flex-column">
          <FdText bold colorTheme4 tag="label">Site</FdText>
          <FdText class="mt-1" tag="span">{{ organizationName }}</FdText>
          <FdText class="mt-1" tag="span">{{ organizationAddress }}</FdText>
        </div>
      </GmbRow>

      <GmbRow alignControlsOnTop class="mt-2">
        <template #picto>
          <FdText colorTheme4 fa>
            <i class="fas fa-biking"/>
          </FdText>
        </template>

        <div class="d-flex flex-column">
          <FdText bold colorTheme4 tag="label">Accessibilité</FdText>
          <div
              v-for="(routeAssessment, i) in routeAssessments"
              :class="['d-flex flex-column', { 'mt-1': i != 0 }]"
              :key="i"
          >
            <FdText class="mt-1" tag="span"
            >{{ routeAssessment.label }} : {{ routeAssessment.value }}
            </FdText
            >
          </div>
        </div>
      </GmbRow>

      <div class="d-flex mt-3 border-top pt-3"/>

      <div
          v-if="canEditIndividual"
          class="d-flex flex-column gmb-control-column__control-container"
      >
        <b-button
            class="d-flex p-1 justify-content-center align-items-center text-size-reset rounded-1"
            variant="primary"
            @click="$emit('switch-to-individual-details')"
        >
          <FdText fa>
            <i class="fas fa-user"/>
          </FdText>

          <FdText class="mx-2" tag="span"
          >Voir&nbsp;/&nbsp;éditer&nbsp;l'individu
          </FdText
          >
        </b-button>
      </div>
    </GmbSection>
  </div>
</template>

<script>
import FdText from "@/flexdesign/Text";

import GmbRow from "@/widgets/Row";
import GmbSection from "@/widgets/Section";

export default {
  name: "GmbIndividualMapPointInfo",

  components: {
    FdText,
    GmbRow,
    GmbSection,
  },

  props: {
    address: String,
    canEditIndividual: Boolean,
    id: String,
    organizationAddress: String,
    organizationName: String,
    routeAssessments: Array,
    transportFilters: Array,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss"></style>
